module.exports = new __parcel__URL__("lowest.e96804a1.svg").toString();